<template>
  <UserDataProvider v-slot="{user, loaded}">
    <v-list
      v-if="loaded"
      nav
      :dense="$vuetify.breakpoint.mdAndUp"
      flat
    >
      <template
        v-for="(item, index) in filteredItems(user)"
      >
          <!-- v-if="(
            ('disabled' in item) ? !item.disabled : true) &&
            (item.accessType ? item.accessType.includes(user.accessType) : true) &&
            (item.roles ? user.hasRole(item.roles) : true)" -->
        <v-list-item
          :key="index"
          replace
          exact
          :href="item.href"
          :to="item.to"
          :target="item.target"
          active-class="active-nav-item"
        >
          <v-list-item-icon>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.text[$i18n.locale]"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </UserDataProvider>
</template>

<script>
import UserDataProvider from '@/components/frames/UserDataProvider'

export default {
  name: 'NavMenu',
  components: {
    UserDataProvider
  },
  props: {
    items: {
      type: Array,
      require: true
    }
  },
  methods: {
    filteredItems (user) {
      const filtered = this.items.filter((item) => {
        const enabled = !('disabled' in item) || ('disabled' in item ? !item.disabled : true)
        const hasAccess = !('accessType' in item) || item.accessType.length === 0 || item.accessType.includes(user.accessType)
        const hasRoles = !('roles' in item) || item.roles.length === 0 || user.hasRole(item.roles)
        return enabled && hasAccess && hasRoles
      })
      return filtered
    }
  }
}
</script>

<style lang="scss">
.active-nav-item {
  color: var(--v-accent-base) !important;
  font-weight: bold;
}
</style>
@/components/frames/UserDataProvider
